import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import {SiteEPC} from './pages/epcsite'
import {CalcDigital} from './pages/epcsite/novadigital'
import { VideosDigital } from './pages/epcsite/videos';
import { CalcDigitalAntigo } from './pages/epcsite/velhadigital'

const GlobalStyle = createGlobalStyle`
  body { margin: 0; }
`;

function App() {
  return (
    <div>
        <GlobalStyle />
        <BrowserRouter>
            <Routes>
                <Route exact  path='/' element={<SiteEPC />} />
                <Route exact  path='/novadigital' element={<CalcDigital />} />
                <Route exact  path='/velhadigital' element={<CalcDigitalAntigo />} />
                <Route exact  path='/videos' element={<VideosDigital />} />

            </Routes>
        </BrowserRouter>
    </div>
  );
}

export default App;
